import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Image from 'next/image'
import { RegularSection, ColorTitle } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'

interface ImageData {
    src?: string
    alt?: string
}

interface Content {
    title?: string
    text?: string
    image?: ImageData
}

interface S3_about_5LProps {
    content?: Content
    blockName?:string
}

const defaultContent: Content = {
    title: 'Who We Are',
    text: 'Skilled European Team with Years of Experience',
    image: { src: '/img/img-160400.jpg', alt: 'man cutting concrete' },
}

const Index = (props: S3_about_5LProps) => {
    const { content = defaultContent } = props
    const { title, text, image = {}} = content
    const heroImage = getImageData(image)
    return (
        <RegularSection aria-label='S3_about_5L' >
            <Grid
                container
                spacing={4}
            >
                <Grid
                    size={{ xs: 12, md: 6, lg: 5 }}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 5,
                        overflow: 'hidden',
                    }}
                >
                    {heroImage.src ? (
                        <Image
                            src={heroImage.src}
                            alt={heroImage.alt || ''}
                            width={670}
                            height={360}
                            style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
                        />
                    ) : null}
                </Grid>
                <Grid
                    size={{ xs: 12, md: 6, lg: 7 }}
                    sx={{ display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'center' }}
                >
                    <ColorTitle title={title} colorFrom={0} textAlign='start'/>
                    <Typography variant='body2'>{text}</Typography>
                </Grid>
            </Grid>
        </RegularSection>
    )
}

export default Index
